angular.module('GatorPad.controllers.Inventory', [])

  .controller('InventoryController', ['$location', '$rootScope', '$scope', 'ApiService', function ($location, $rootScope, $scope, ApiService) {

  $scope.farmList = [];
  $scope.barnList = [];
  $scope.tankList = [];
  $scope.entryDate = new Date();
  $scope.entryDate.setHours(0, 0, 0, 0);

  if (navigator.onLine) {
    ApiService.initializeData()
      .then(function () {
        $scope.farmList = ApiService.getFarms();
      }, function (err) {
        $scope.error = "Could not load " + err + " data.";
      });
  } else {
    $scope.farmList = ApiService.getFarms();
  }

  $scope.selectBarn = function () {
      $scope.tankList = [];
      if ($scope.selectedBarn) {
        angular.forEach(ApiService.getTanks($scope.selectedBarn.id), function (tank) {
          var currentInventory = tank.inventory.beginning;
          if (tank.inventory.dead) {
            currentInventory -= tank.inventory.dead;
          }
          if (tank.inventory.harvest) {
            currentInventory -= tank.inventory.harvest;
          }
          if (tank.inventory.transfer_in) {
            currentInventory += tank.inventory.transfer_in;
          }
          if (tank.inventory.transfer_out) {
            currentInventory -= tank.inventory.transfer_out;
          }
  
          var tankData = window.localStorage.getItem("INVENTORY." + $scope.entryDate.toDateString() + "." + $scope.selectedFarm.id + "." + $scope.selectedBarn.id + "." + tank.id);
          if (tankData) {
            tankData = JSON.parse(tankData);
            $scope.tankList.push({ id: tank.id, name: tank.name, currentInventory: currentInventory, dead: tankData.dead, harvest: tankData.harvest, transfer_in: tankData.transfer_in, transfer_out: tankData.transfer_out });
          } else {
            $scope.tankList.push({ id: tank.id, name: tank.name, currentInventory: currentInventory, dead: 0, harvest: 0, transfer_in: 0, transfer_out: 0 });
          }
        });
      }
  };

  $scope.save = function () {
    angular.forEach($scope.tankList, function (tank) {
      var storageKey = "INVENTORY." + $scope.entryDate.toDateString() + "." + $scope.selectedFarm.id + "." + $scope.selectedBarn.id + "." + tank.id;
      if (tank.dead > 0 || tank.harvest > 0 || tank.transfer_in > 0 || tank.transfer_out > 0) {
        var storageValue = JSON.stringify({ entryDate: $scope.entryDate, entryDateDisplay: $scope.entryDate.toDateString(), farmName: $scope.selectedFarm.name, barnName: $scope.selectedBarn.name, barnId: $scope.selectedBarn.id, tankName: tank.name, tankId: tank.id, dead: tank.dead, harvest: tank.harvest, transfer_in: tank.transfer_in, transfer_out: tank.transfer_out });
        window.localStorage[storageKey] = storageValue;
      } else {
        window.localStorage.removeItem(storageKey);
      }
    });

    $scope.saveModalTitle = "Inventory Save";
    $scope.saveModalBody = "The inventory counts have been saved.";
    $rootScope.Ui.turnOn('modalSave');
  };

}]);